import React, { Component } from "react";
import { connect } from "react-redux";
import ProjectQaWeldingInspectionsInspectionCriteriaForm from "./form";
import { createProjectQaWeldingInspectionsInspectionCriteria } from "../actions";
import { Form } from "react-final-form"
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
function mapStateToProps(state) {
return {};
}
class NewProjectQaWeldingInspectionsInspectionCriteriaSliding extends Component {
constructor(props) {
super(props);
this.submitForm = this.submitForm.bind(this);
this.successfullySubmitted = this.successfullySubmitted.bind(this);
this.state = {
isOpen:this.props.isOpen
}
}
componentDidUpdate(prevProps, prevState) {
const prevIsOpen = prevState.isOpen
const { isOpen } = this.props
if(prevIsOpen != isOpen){
this.setState({isOpen:isOpen})
}
}
submitForm(values) {
const createRequest = this.props.createProjectQaWeldingInspectionsInspectionCriteria(values);
createRequest.then(this.successfullySubmitted)
}
successfullySubmitted() {
const { toggle } = this.props
toggle()
toastr.success("Created New Inspection criteria")
}
render() {
const { isOpen } = this.state
const { toggle } = this.props
return (
<SlidingPane isOpen={isOpen} onRequestClose={toggle} title="New Inspection criteria" width="50%">
				<Form
					component={ProjectQaWeldingInspectionsInspectionCriteriaForm}
					formLabel="Create"
					onSubmit={this.submitForm} 
					cancelFunction={toggle}
					{...this.props}
				/>
</SlidingPane>
);
}
}
export default connect(mapStateToProps,{ createProjectQaWeldingInspectionsInspectionCriteria })(NewProjectQaWeldingInspectionsInspectionCriteriaSliding);
